import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const projects = [
  {
    id: 1,
    title: "The Graham",
    description: "Experience comfort and style with our modern luxury apartments.",
    image: "/images/graham1.jpg",
  },
  {
    id: 2,
    title: "Smart Homes For Sale",
    description: "Beautiful smart homes designed with elegance and innovation.",
    image: "/images/solosec1.jpg",
  },
  {
    id: 3,
    title: "Office Complex",
    description: "State-of-the-art office spaces built for productivity and growth.",
    image: "/images/project3.jpg",
  },
  {
    id: 4,
    title: "Homes For Rent",
    description: "Premium retail home located at Burma Hills(Tse Addo), perfect for families and professionals.",
    image: "/images/redsolonetrent.png",
  },
  {
    id: 5,
    title: "4 Bedrooms For Sale",
    description: "State-of-the-art homes built for families and professionals.",
    image: "/images/tse1.jpeg",
  },
    {
    id: 6,
    title: "5 Bedrooms For Sale",
    description: "Luxurious 5-bedroom homes designed for spacious family living.",
    image: "/images/un1.png",
  },
];

const Projects = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      {/* HEADER SECTION WITH BACKGROUND IMAGE */}
      <div className="relative w-full h-[60vh] flex items-center justify-center">
        <img
          src="/images/header.jpg"
          alt="Projects Header"
          className="absolute top-0 left-0 w-full h-full object-cover"
        />

        {/* Dark Overlay */}
        <div className="absolute top-0 left-0 w-full h-full bg-black/50"></div>

        {/* Text Content */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="relative z-10 text-center px-4"
        >
          <h1 className="text-4xl md:text-6xl font-bold text-white drop-shadow-lg">
            Our Projects
          </h1>
          <p className="text-gray-200 mt-4 text-lg md:text-xl max-w-2xl mx-auto">
            Discover our premium developments — from luxury apartments to
            exclusive villas and commercial spaces.
          </p>
        </motion.div>
      </div>

      {/* PROJECTS GRID */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {projects.map((project) => (
            <motion.div
              key={project.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition duration-300 group"
              whileHover={{ scale: 1.05 }}
            >
              {/* Project Image */}
              <div className="relative w-full h-56 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition duration-500"
                />
                <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition duration-500"></div>
              </div>

              {/* Project Info */}
              <div className="p-6">
                <h3 className="text-2xl font-semibold text-gray-800">
                  {project.title}
                </h3>
                <p className="text-gray-600 mt-3">{project.description}</p>

                {/*  Use Link instead of <a> */}
                <Link
                  to={`/projects/${project.id}`}
                  className="inline-block mt-5 text-blue-600 hover:text-blue-800 font-medium transition"
                >
                  View Details →
                </Link>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Projects;
